import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Col, Row, Alert } from 'reactstrap';

// Local Deps
import './AddTooling.scss';
import AddToolingForm from '../forms/AddToolingForm';
import AddToolingHOC from './AddToolingHOC';


class AddTooling extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    formValues: PropTypes.object.isRequired,
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    hideMessage: PropTypes.func.isRequired,
    handleInitalValueReset: PropTypes.func.isRequired,
    onReturnToMainPage: PropTypes.func.isRequired,
  };

  static initialState = {};

  state = AddTooling.initialState;

  render() {
    const {
      onSubmit,
      alertType,
      alertMessage,
      formValues,
      hideMessage,
      handleInitalValueReset,
      onReturnToMainPage
    } = this.props;

    return (
      <div className="nf-add-tool">
        <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Add Tooling Page</title>
        </Helmet>
        <Row id='addToolingContainer'>
          <Col>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'space-around',
              }}
            >
              <Alert color="light" style={{ fontSize: '.75rem' }} />
            </Row>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'space-around',
              }}
            >
              {alertMessage && (
                <Alert color={alertType} toggle={hideMessage}>
                  {alertMessage}
                </Alert>
              )}
            </Row>


            {/* <!-- FORM --> */}
            <Row>
              <div className="nf-add-tool__form">
                <AddToolingForm
                  onSubmit={onSubmit}
                  initialValues={formValues}
                  handleInitalValueReset={handleInitalValueReset}
                  onReturnToMainPage={onReturnToMainPage}
                />
              </div>
            </Row>


          </Col>

        </Row>
      </div>
    );
  }
}

export default AddToolingHOC(AddTooling);



// WEBPACK FOOTER //
// ./src/components/AddTooling/AddTooling.jsx